/*
 * Global actions
 */

/** Error action constant */
export const CLEAR_ACTION_RESPONSE = 'DFIM_CLEAR_ACTION_RESPONSE';

/**
 * Clear error, this action starts the clear error epic
 * @return {object} An action object with a type of CLEAR_ERROR
 */
export const clearActionResponse = () => ({ type: CLEAR_ACTION_RESPONSE });
